export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT
export const CHART_ENDPOINT = import.meta.env.VITE_CHART_API_ENDPOINT

if (!API_ENDPOINT) {throw new Error("missing API_ENDPOINT")}
if (!CHART_ENDPOINT) {throw new Error("missing API_ENDPOINT")}

export class InvalidResponseError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'InvalidResponseError'
  }
}

export class HttpService {
  public headers: Headers

  constructor() {
    this.headers = new Headers()
    this.headers.append('Content-Type', 'application/json')
  }

  public async query(path: string, request: RequestInit): Promise<Response> {
      const params = { method: request.method, body: request.body, headers: this.headers }
      return await fetch(path, params)
  }

  setAuth(jwt:string) {
    this.headers.set('Authorization', `Bearer ${jwt}` )
  }

  clearAuth() {
    this.headers.delete('Authorization')
  }

}

export const httpService = new HttpService()